function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "PT/Icons/Logout",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C6.4856775,2 2,6.4856775 2,12 C2,17.5143233 6.4856775,22 12,22 C16.6484375,22 20.5481775,18.8066408 21.6614583,14.5 L19.9427083,14.5 C18.878255,17.8789067 15.7239583,20.3333333 12,20.3333333 C7.40364583,20.3333333 3.66666667,16.5963542 3.66666667,12 C3.66666667,7.40364583 7.40364583,3.66666667 12,3.66666667 C15.7239583,3.66666667 18.878255,6.12109417 19.9427083,9.5 L21.6614583,9.5 C20.5481775,5.19335917 16.6484375,2 12,2 Z M12.546875,8.06770833 L9.21354167,11.4010417 L8.640625,12 L9.21354167,12.5989583 L12.546875,15.9322917 L13.7447917,14.734375 L11.84375,12.8333333 L22,12.8333333 L22,11.1666667 L11.84375,11.1666667 L13.7447917,9.265625 L12.546875,8.06770833 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}));

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PT/Icons/Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.e70c1de2.svg";
export { ForwardRef as ReactComponent };